<template>
  <div class="attachments-container">
    <div v-if="error" class="alert alert-danger full">{{error}}</div>
    <div v-for="(oClass) in classesUnified"
        :id="oClass.kind"
        v-if="oClass.secure !== $root.isEmbeddedMode && (!oClass.showIf || meetsRequirements({requires: oClass.showIf}))"
        :class="oClass.compact ? 'compact' : 'full'" >
      <div style="flex: 1">
        <div class="ptop-10 pright-10 pleft-10" v-if="oClass.kind === 'attachment' && attachmentsRequirementsHints.length">
          <div class="alert alert-warning">
            <div v-for="msg in attachmentsRequirementsHints">{{msg}}</div>
          </div>
        </div>
        <h4 v-if="oClass.title" class="">
          <span v-html="$t(oClass.title)"></span>
          <i v-if="oClass.requires > 0" class="color-orange fa fa-asterisk" aria-hidden="true"></i>
          <a v-if="oClass.tooltip" :href="tooltipUrl(oClass.tooltip)" target="_blank" :data-balloon-length="tooltipLength(oClass.tooltip)" :data-balloon="tooltipText(oClass.tooltip)" :data-balloon-pos="tooltipOrientation(oClass.tooltip)">
            <i class="fa fa-info-circle"></i>
          </a>
        </h4>
        <div class="alert alert-danger" style="margin: 0 20px" v-if="validation['attachment_' + oClass.kind] === false">
          {{$t(oClass.error || 'ProjectDetails.missingAttachments')}}
        </div>
        <attachments
          :ref="'attachment_' + oClass.kind"
          :url="baseUrl + '/' + oClass.kind"
          :readonly="readonly"
          :maxFilesize="oClass.sizeLimit || sizeLimit || undefined"
          :maxFiles="oClass.fileLimit || fileLimit || undefined"
          :minFiles="oClass.requires || undefined"
          :accepted-files="oClass.fileTypes || fileTypes || undefined"
          :placeholder="oClass.placeholder"
          :file-names="oClass.fileNames || fileNames || undefined"
          :error-message="oClass.errorMessage || errorMessage || undefined"
          :dropzone-height="oClass.height || dropzoneHeight || undefined"
          :compact="oClass.compact"
          :show-hash="oClass.showHash === true"
          v-on:error="handleAttachmentError"
          v-on:loaded="(attachments) => handleAttachment(oClass.kind, attachments)"
          v-on:status="emitStatus"
          v-on:valid="(isValid) => handleValidation('attachment_' + oClass.kind, isValid)"
        ></attachments>
      </div>
    </div>
  </div>
</template>
<script>
  import Attachments from './Attachments.vue';
  import FormsMixin from '../Mixins/Forms.js';
  import ProjectMasterDataTab from './ProjectMasterDataTab.vue';

  export default {
    name: 'TabAttachments',
    mixins: [
      FormsMixin
    ],
    components: {
      Attachments,
      ProjectMasterDataTab,
    },
    props: {
      baseUrl: String,
      classes: { type: [Object, Array], default: () => {} },
      readonly: { type: Boolean, default: false },
      formValues: Object,
      itemNums: Object,
      itemNumsAll: Object,
      form: Array,
      fileTypes: { type: [String, Array] },
      sizeLimit: { type: [Number, null] },
      fileLimit: { type: [Number, null] },
      fileNames: { },
      errorMessage: { type: [String, Object], default: null},
      dropzoneHeight: { type: Number },
      requirements: { type: Array, default: []},
      attachmentsRequirementsHints: {type: Array},
    },
    watch: {
      formValues(formValues) { // watch it
        this.formValues = formValues;
        this.validate();
      },
      itemNums(itemNums) { // watch it
        this.itemNums = itemNums;
        this.validate();
      },
      itemNumsAll(itemNumsAll) { // watch it
        this.itemNumsAll = itemNumsAll;
        this.validate();
        this.$forceUpdate()
      },
      requirements(requirements) { // watch it
        this.requirements = requirements;
        this.validate();
      }
    },
    data: function() {
      return {
        error: '',
        validation: {},
      }
    },
    computed: {
      classesUnified() {
        if (Array.isArray(this.classes)) {
          return this.classes;
        }

        return Object.entries(this.classes).map(([key, value]) => Object.assign({}, value, {kind: key}));
      }
    },
    methods: {
      tooltipText(tooltip) {
        if (this.tooltipUrl(tooltip)) {
          return undefined;
        }
        return this.$t(tooltip);
      },
      tooltipLength(tooltip) {
        return undefined;
      },
      tooltipOrientation(tooltip) {
        return undefined;
      },
      tooltipUrl(tooltip) {
        if (typeof tooltip === 'string') {
          if (tooltip.startsWith('http://') || tooltip.startsWith('https://')) {
            return tooltip;
          }
          return undefined;
        }

        if (tooltip.url) {
          return tooltip.url;
        }
      },
      handleAttachmentError(errMsg) {
        this.$emit('error', errMsg);
      },
      handleAttachment(className, attachments) {
        this.$emit('uploaded', attachments);
        this.validate();
      },
      emitStatus(status, file, message) {
        if (status === 'error') {
          this.$emit('error', message || this.$t('File.errorUpload'));
        }
      },
      handleValidation(name, isValid) {
        this.validation[name] = isValid;

        this.validate();
      },
      handleFormInput(value, field) {
        this.formValues[field.name] = value;
        this.$forceUpdate();
        this.validate();
      },
      validate() {
        setTimeout(() => {
          const errors = [];
          let attachmentsMet = true;

          if (Object.keys(this.classes).indexOf('attachment') >= 0) {
            attachmentsMet = attachmentsMet && !this.attachmentsRequirementsHints.length;
          }

          this.requirements.forEach(x => {
            if (!checkCondition(this.$refs, x.requires)) {
              attachmentsMet = false;
              errors.push(this.$t(x.message || 'ProjectDetails.missingAttachments'));
            }
          });

          const valid = Object.keys(this.$refs)
            .filter(key => this.$refs[key].length > 0 || key === 'form')
            .every((key) => this.validation[key] !== false)

          &&

            attachmentsMet;

          this.error = errors.join('<br/>');

          this.$emit('valid', valid);

          this.$forceUpdate();
        });

        this.$forceUpdate();
      },
      getItemNums() {
        return this.$refs.form ? this.$refs.form.getItemNums() : [];
      }
    },
  }


  function checkCondition(files, condition, op, key) {
    if (key) {
      const [component = null] = files[`attachment_${key}`] || [];
      if (component == null) {
        return true;
      }
      const values = component.attachments || [];

      switch (typeof condition) {
        case 'undefined':
        case 'null':
          return values.length === 0;

        case 'boolean':
          return !!values.length === condition;

        case 'number':
          return values.length === condition;

        case 'string':
          const regExp = new RegExp(condition);
          return values.some(({filename: name}) => regExp.test(name) || name === condition);

        default:
          if (Array.isArray(condition)) {
            return condition.every(condition => checkCondition(files, condition, null, key));
          }

          throw new Error(`Unexpected condition for key ${key} = ${JSON.stringify(condition)}`);
      }
    }

    if (op && op !== 'every' && op !== 'some') {
      throw new Error(`Unknown operation ${op}`);
    }

    if (Array.isArray(condition)) {
      return condition[op || 'some'](condition => checkCondition(files, condition));
    }

    if (typeof condition !== 'object') {
      throw new Error(`Unexpected condition object ${JSON.stringify(condition)}`);
    }

    return Object.entries(condition)
      [op || 'every']
    (([key, condition]) => {
      switch (key) {
        case '$and':
          return checkCondition(files, condition, 'every');

        case '$or':
          return checkCondition(files, condition, 'some');

        case '$not':
          return !checkCondition(files, condition);

        default:
          if (key.startsWith('$')) {
            throw new Error(`Unknown operator ${key}`);
          }

          return checkCondition(files, condition, null, key);
      }
    })
  }

</script>
<style>
  .attachments-container {
    display: flex;
    flex: 1;
    flex-direction: row;
    flex-wrap: wrap;
  }

  .attachments-container .full {
    flex: 0;
    min-width: 100%;
  }

  .attachments-container .compact {
    display: flex;
    flex: 1;
    min-width: 300px;
  }
</style>
